import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Classes from './RecordTable.module.css';
import backend from '../../../../../../api';

export default function MoreDropDown({ index, user, sendEmail, getAllInvites }) {
    const [dropDown, setDropDown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropDown(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleResendInvite = () => {
        if (user.status === 'Pending Invitation') {
            sendEmail(user.id, user.role, user.backendRole, user.email, false);
        }
        setDropDown(false);
    };

    const handleDelete = async () => {
        if (user.status === 'Active') {
            try {
                await backend.delete(`/api/user/${user.userId}`);
                await backend.delete(`/api/invite/${user.id}`);
                console.log('User and invitation deleted:', user.id);
                getAllInvites();
            } catch (error) {
                console.error('Error deleting user:', error);
            }
        } else if (user.status === 'Pending Invitation') {
            try {
                await backend.delete(`/api/invite/${user.id}`);
                console.log('Invitation deleted:', user.id);
                getAllInvites();
            } catch (error) {
                console.error('Error deleting invitation:', error);
            }
        }
        setDropDown(false);
    };

    return (
        <div className={Classes.dropDown} ref={dropdownRef}>
            <div className="flexAlign10 pointer mr10" onClick={() => setDropDown(!dropDown)}>
                <div className={Classes.dropdownIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" height='15px' viewBox="0 0 128 512">
                        <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
                    </svg>
                </div>
            </div>
            <AnimatePresence>
                {dropDown && (
                    <motion.div
                        initial={{ opacity: 0, y: -5 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -5 }}
                        transition={{ duration: 0.15 }}
                        className={Classes.dropDownBody}
                        style={{ top: '13px', right: '54px' }}
                    >
                        <div className={Classes.dropDownBodyInner}>
                            {user.status === 'Pending Invitation' && (
                                <>
                                    <div
                                        className={Classes.dropDownElem}
                                        style={{ padding: '5px 10px' }}
                                        onClick={handleResendInvite}
                                    >
                                        <h5>Send reminder</h5>
                                    </div>
                                    <div className={Classes.dropDownLine}></div>
                                </>
                            )}
                            <div
                                className={Classes.dropDownElem}
                                style={{ padding: '5px 10px', color: 'red' }}
                                onClick={handleDelete}
                            >
                                <h5>Delete</h5>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            <input type="hidden" aria-label="Without label" readOnly />
        </div>
    );
}